import React, { useEffect, useState } from "react";
import AdminSettingsSponsors from "./AdminSettingsSponsors"; // Napravi ove fajlove
import AdminSettingsRewards from "./AdminSettingsRewards";
import AdminSettingsHowTo from "./AdminSettingsHowTo";
import LoaderBox from "../HomePage/LoaderBox";
import AdminSettingsParty from "./AdminSettingsParty";
import AdminBelaTurnir from "./AdminBelaTurnir";
import AdminSettingsWeb from "./AdminSettingsWeb";
import AdminSettingsCountDown from "./AdminSettingsCountDown";
import AdminSettingsArhiva from "./AdminSettingsArhiva";
import AdminSettingsStats from "./AdminSettingsStats";

const AdminSettings = ({ settingsPage, setSettingsPage }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 600);
    return () => clearTimeout(timer);
  }, []);
  const [loading, setLoading] = useState(true);
  // 1. Ako smo unutar pod-stranice sponzora
  if (settingsPage === "countdown") {
    return <AdminSettingsCountDown onBack={() => setSettingsPage("menu")} />;
  }
  if (settingsPage === "archive") {
    return <AdminSettingsArhiva onBack={() => setSettingsPage("menu")} />;
  }
  if (settingsPage === "belaTurnir") {
    return <AdminBelaTurnir onBack={() => setSettingsPage("menu")} />;
  }
  if (settingsPage === "sponsors") {
    return <AdminSettingsSponsors onBack={() => setSettingsPage("menu")} />;
  }

  if (settingsPage === "rewards") {
    return <AdminSettingsRewards onBack={() => setSettingsPage("menu")} />;
  }

  if (settingsPage === "howto") {
    return <AdminSettingsHowTo onBack={() => setSettingsPage("menu")} />;
  }

  if (settingsPage === "party") {
    return <AdminSettingsParty onBack={() => setSettingsPage("menu")} />;
  }

  if (settingsPage === "stats") {
    return <AdminSettingsStats onBack={() => setSettingsPage("menu")} />;
  }

  if (settingsPage === "webControl") {
    return <AdminSettingsWeb onBack={() => setSettingsPage("menu")} />;
  }

  // 3. DEFAULT: Glavni izbornik postavki
  const adminOptions = [
    /*    {
      id: "password",
      title: "Promjena lozinke",
      icon: "fi-rs-key",
      color: "#FFD700",
    }, */
    {
      id: "countdown",
      title: 'Uredi "Odbrojavanje"',
      icon: "fi-rs-hourglass-end",
      color: "#5ef1bbff",
    },
    {
      id: "archive",
      title: 'Uredi "Arhivu Pobjednika"',
      icon: "fi-rs-trophy",
      color: "#FFD700",
    },
    {
      id: "belaTurnir",
      title: 'Uredi "Bela turnir"',
      icon: "fi-rs-card-spade",
      color: "#f1cc5eff",
    },
    {
      id: "rewards",
      title: 'Uredi "Nagradni fond"',
      icon: "fi-rs-trophy",
      color: "#00FF00",
    },
    {
      id: "sponsors",
      title: 'Uredi "Sponzore"',
      icon: "fi-rs-handshake",
      color: "#00BFFF",
    },
    {
      id: "howto",
      title: 'Uredi "Kako do nas?"',
      icon: "fi-rs-marker",
      color: "#66ddc7ff",
    },
    {
      id: "party",
      title: 'Uredi "Događaje"',
      icon: "fi-rs-party-horn",
      color: "#FF4500",
    },
    {
      id: "stats",
      title: "Statistika turnira",
      icon: "fi-rs-chart-simple",
      color: "#ccc12eff",
    },
    {
      id: "webControl",
      title: "Kontrola i Održavanje Weba",
      icon: "fi-rs-user-permissions",
      color: "#cc2e85ff", // Tvoja zadana zelenkasta boja
    },
  ];

  if (loading) return <LoaderBox text="Učitavanje..." />;

  return (
    <div className="admin-settings-menu">
      <div className="admin-header">
        <h3>Postavke</h3>
      </div>
      <div className="admin-grid">
        {adminOptions.map((opt) => (
          <div
            key={opt.id}
            className="admin-card"
            onClick={() => setSettingsPage(opt.id)}
          >
            <i className={`fi ${opt.icon}`} style={{ color: opt.color }}></i>
            <span>{opt.title}</span>
            <i className="fi fi-rs-angle-small-right"></i>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminSettings;
